import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import api from "../utils/request";

const CartContext = createContext({
  cartCount: 0,
  refreshCartCount: () => {},
  syncCartCount: () => {},
});

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const { pathname } = useLocation();

  const refreshCartCount = useCallback(async () => {
    if (!localStorage.getItem("token")) {
      setCartCount(0);
      return;
    }

    try {
      const data = await api.post("customer/getCartList");
      if (data?.status === false) return;
      setCartCount(Number(data?.cart_total_items) || 0);
    } catch (error) {
      console.error("Failed to fetch cart count:", error);
    }
  }, []);

  const syncCartCount = useCallback(
    (count) => {
      if (count === undefined || count === null || count === "") {
        refreshCartCount();
        return;
      }

      const parsedCount = Number(count);
      setCartCount(Number.isFinite(parsedCount) ? parsedCount : 0);
    },
    [refreshCartCount],
  );

  useEffect(() => {
    refreshCartCount();
  }, [refreshCartCount]);

  useEffect(() => {
    if (pathname === "/success") {
      refreshCartCount();
    }
  }, [pathname, refreshCartCount]);

  return (
    <CartContext.Provider
      value={{ cartCount, refreshCartCount, syncCartCount }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
